<template>
  <div class="link-3ds">
    <div
      v-if="!form[field.key] || !form[field.key].length"
      class="text-primary"
    >
      Chưa có link 3ds
    </div>
    <el-row
v-else
class="list-link mb-l"
:gutter="16">
      <el-col
        v-for="(l, index) in form[field.key]"
        :key="index"
        :lg="8"
        :md="12"
        :sm="12"
        :span="24"
        class="mt-m"
      >
        <div style="display: flex; align-items: center; width: 100%">
          <el-input
:value="l"
:disabled="disabled" />
          <el-button
            v-if="!disabled"
            type="danger"
            class="remove-link ml-xs"
            :disabled="disabled"
            @click="handleRemoveLink(l)"
          >
            <i class="el-icon-close" />
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-input
      v-if="!disabled"
      v-model="link"
      class="w-50"
      placeholder="Nhập link 3d"
      @keyup.native.enter="handleAddLink"
    >
      <el-button
slot="append"
@click="handleAddLink">
        <i class="el-icon-plus" />
      </el-button>
    </el-input>
  </div>
</template>

<script>
import patterns from "@/config/patterns";
export default {
  name: "Youtube",
  props: {
    form: Object,
    field: Object,
    disabled: Boolean,
  },
  data() {
    return {
      link: "",
    };
  },
  methods: {
    handleAddLink() {
      if (this.link) {
        const regExp = patterns.LINK;
        if (this.link.match(regExp)) {
          if ((this.form[this.field.key] || []).find((l) => l === this.link)) {
            this.$notify.warning({
              title: "Thông báo",
              message: "Link 3d đã tồn tại.",
            });
          } else {
            this.form[this.field.key].push(this.link);
            this.link = "";
          }
        } else {
          this.$notify.warning({
            title: "Thông báo",
            message: "Link 3d không đúng định dạng.",
          });
        }
      } else {
        this.$notify.warning({
          title: "Thông báo",
          message: "Chưa nhập link 3d.",
        });
      }
    },

    handleRemoveLink(link) {
      this.form[this.field.key] = this.form[this.field.key].filter(
        (l) => l !== link
      );
    },
  },
};
</script>

<style lang="scss" scoped>
//
</style>
